import { useCallback } from 'react';
import type { AnalyticsPowersDashboard } from '@/types/analytics/dashboard';
import { getPowersDashboard } from '@/services/analytics/dashboard.service';
import { useAnalyticsSection } from './use-analytics-section';

const EMPTY: AnalyticsPowersDashboard = {
  totalViews: 0,
  openPowerClicks: 0,
  viewSmiliesClicks: 0,
  topCategory: null,
  topPowers: [],
  recentLaunchAccess: [],
  powers: [],
};

export function useAnalyticsPowers() {
  const loader = useCallback(() => getPowersDashboard(), []);
  return useAnalyticsSection(loader, EMPTY);
}
